import React, {memo} from 'react';
import DialogComponent from 'components/Dialog';
import {DialogTypes} from 'common/names';
import {IUserActivityReportParameters} from 'types/diplomat/reports/UserActivityReportParameters';

import {useDownloadPostApi} from 'common/hooks/useDownloadPostApi';
import api from 'api';
import {UserActivityReportForm} from './UserActivityReportForm';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {enums} from 'types/enums';

type Props = {
   onClose: () => void;
};
export const UserActivityReportDialog = memo(({onClose}: Props) => {
   const {download} = useDownloadPostApi();
   const sendParameters = React.useCallback(
      (
         values: IUserActivityReportParameters,
         bag: FormOnSubmitHelpers<IUserActivityReportParameters>
      ) => {
         const url =
            values._format === enums.reportFormats.enum.CSV
               ? api.useractivity + 'csv'
               : api.useractivity;

         download(url, JSON.stringify(values), {
            onSuccess: () => bag.setSubmitting(false),
            onFailure: (errors: any) => {
               bag.setSubmitting(false);
               bag.setErrors(errors);
            },
         });
      },
      [download]
   );

   return (
      <DialogComponent
         maxWidth="lg"
         header={DialogTypes.UserActivityReportDialog.dialogName}
         close={onClose}
      >
         <UserActivityReportForm onClose={onClose} onSubmit={sendParameters} />
      </DialogComponent>
   );
});
